export class Image {
    constructor(source) {
        this.Height = source.height;
        this.Src = source.src;
        this.Title = source.Title;
        this.Type = source.Type;
        this.Width = source.width;
    }
}
//# sourceMappingURL=Image.js.map